export const Permissions = Object.freeze({
    DRIVER_READ: "services:driver::read",
    DRIVER_WRITE: "services:driver::write",
    USERS_READ: "users::read",
    USERS_CREATE: "users::create",
    USERS_WRITE: "users::write",
    USERS_DELETE: "users::delete",
    EMPLOYEES_READ: "employees::read",
    COST_CENTER_READ: "cost_center::read",
    COST_CENTER_CREATE: "cost_center::create",
    COST_CENTER_DELETE: "cost_center::delete",
    COST_CENTER_EMPLOYEES_DELETE: "cost_center:employees::delete",
    SERVICES_READ: "services::read",
    SERVICES_CREATE: "services::create",
    UNASSIGN_SERVICES: "service::assign:edit", 
    CONTROL_TOWER_SERVICES_READ: "control_tower:services::read",
    CREATE_EMPLOYEE: "employees::create",
    DELETE_EMPLOYEE: "employees::delete",
    WRITE_EMPLOYEE: "employees::write",
    // Módulo de Validación/Edición de Servicios TP
    SERVICE_VALIDATION_MENU_READ: "services:validation:menu::read",
    SERVICE_VALIDATION_LIST: "services:validation::list",
    SERVICE_VALIDATION_READ: "services:validation::read",
    SERVICE_VALIDATION_WRITE: "services:validation::write",
    // Lanzar la consolidación de baseline (Feature 1).
    SERVICE_VALIDATION_BASELINE_WRITE: "services:validation:baseline::write",
    SERVICE_VALIDATE: "services::validate",
    // Dashboard de KPIs de validación (D7). Formato real del repo (ver plan GRS §5c).
    SERVICE_VALIDATION_DASHBOARD_READ: "services:validation:dashboard::read",
    // Configuración de autovalidación por kms (contrato compartido con el backend).
    SERVICE_VALIDATION_CONFIG: "services:validation:config::write",
    // Liberar on-hold AJENO para que otro usuario tome el servicio (FEAT-002).
    SERVICE_VALIDATION_ON_HOLD_WRITE: "services:validation:on_hold::write",
});

export const TypeAddress = Object.freeze({
    ORIGIN: 'origin',
    DESTINY: 'destiny',
    ARRAY_EMPLOYEES: 'arrayEmployees',
    ARRAY_SCALES: 'arrayScales',
});

export const Languages = Object.freeze({
    ES: 'sp',
    EN: 'en',
});

export const TypeService = Object.freeze({
    REQUEST: "request",
    RESERVATIONS: "reservations",
    ASSIGNMENT: "assignment",
});

export const BookingType = Object.freeze({
    CLOSED: "CLOSED",
    OPEN: "OPEN",
    ARRIVAL: "ARRIVAL",
    LEAVING: "LEAVING",
    FINISHED: "FINISHED",
});

export const BookingStatus = Object.freeze({
    ASSIGNED: "ASSIGNED",
    REJECTED: "REJECTED",
    FINISHED: "FINISHED",
    DELETED: "DELETED",
    STARTED: "STARTED",
});

export const FilterType = Object.freeze({
    COMPANY: 'company',
    STATUS: 'status',
    TYPE: 'type',
    CODE: 'code',
    PAGE: 'page',
    PLACE: 'place_id',
    PLATE: 'plate',
    SCHEDULED: 'scheduled_type',
    START_DATETIME: 'start_datetime',
    END_DATETIME: 'end_datetime',
    START_DATE: 'start_date',
    START_TIME: 'start_time',
    END_DATE: 'end_date',
    END_TIME: 'end_time',
});

export const VisibilityTypes = Object.freeze({
    COMPANY: "company",
    COST_CENTER: "costCenter",
    GENERAL: "general",
    DATE_HOUR: "datehour",
    ADDITIONAL_NOTE: "additionalNote",
    TYPE_SERVICE: "typeService",
    ADDRESSES: "addresses",
    UNITS: "units",
    IDTAG: "idtag",
    TAGS: 'tags',
    EMPLOYEES: "employees",
    SCALES: "scales",
    SELECTED_ROUTE: "selectedRoute",
    PASSENGERS: "passengers",
});

export const AlertMessages = Object.freeze({
    SUCCESS: "SuccessRequestService",
    ERROR: "ErrorRequestService",
});

export const DataActions = Object.freeze({
    GET_REQUESTS: "GET_REQUESTS",
    GET_BOOKINGS: "GET_BOOKINGS",
    GET_DRIVERS: "GET_DRIVERS",
});

export const DriverStatus = Object.freeze({
    ALL: "ALL",
    FREE: "FREE",
});

export const UserActions = Object.freeze({
    ADD_USER: "add_user",
    ACTIVATE_USER: "activate_user",
    DEACTIVATE_USER: "deactivate_user",
    DELETE_USER: "delete_user",
});

export const StreamType = Object.freeze({
    REQUEST_CREATED: 'REQUEST_CREATED',
    REQUEST_DELETED: 'REQUEST_DELETED',
    REQUEST_UPDATED: 'REQUEST_UPDATED',
    BOOKING_CREATED: 'BOOKING_CREATED',
    BOOKING_DELETED: 'BOOKING_DELETED',
    BOOKING_UPDATED: 'BOOKING_UPDATED',
    DRIVER_ONLINE: 'DRIVER_ONLINE',
    DRIVER_OFFLINE: 'DRIVER_OFFLINE',
});

export const ServiceStatus = Object.freeze({
    FINISHED: "FINISHED",
    ASSIGNED: "ASSIGNED",
    REJECTED: "REJECTED",
    UNASSIGNED: "UNASSIGNED",
    DELETED: "DELETED",
    STARTED: "STARTED",
});

export const EmployeeStatus = Object.freeze({
    ACTIVE: "ACTIVE",
    INACTIVE: "INACTIVE",
});

export const UserType = Object.freeze({
    STAFF: "STAFF",
    USER: "USER",
    ADMIN: "ADMIN",
    EMPLOYEE: "EMPLOYEE",
});

export const Environments = Object.freeze({
    DEVELOPMENT: "development",
    STAGING: "staging",
    PRODUCTION: "production",
});

export const ServiceEventType = Object.freeze({
    CREATED: "SERVICE_CREATED",
    STARTED: "SERVICE_STARTED",
    STARTED_FROM_SYSTEM: "SERVICE_STARTED_FROM_SYSTEM",
    COMPLETED: "SERVICE_COMPLETED",
    FINISHED_FROM_SYSTEM: "SERVICE_FINISHED_FROM_SYSTEM",
    CANCELLED: "SERVICE_CANCELLED",
    ORIGIN_PICKUP: "ORIGIN_PICKUP",
    DESTINATION_DROPOFF: "DESTINATION_DROPOFF"
});

export const ServiceScheduledType = Object.freeze({
    ON_DEMAND: "ON_DEMAND",
    RESERVED: "RESERVED",
});

export const RoutingServiceType = Object.freeze({
    AFORO: "Aforo",
    DESAFORO: "Desaforo",
    NORMAL: "Normal",
});

export const NOTE_MAX_LENGTH = 500;

// Placa MAG776A = flota Uber. Los servicios con esta placa se agrupan bajo el
// grupo "Uber" en la vista de validación (agrupación de dos niveles
// Uber -> Empresa). Regla de negocio de una sola placa literal.
export const UBER_PLATE = "MAG776A";

// bookings.company_id de clientes (Syscom*, Ecla, Walmart) para los que la UI
// exige que EXISTAN PODs/evidencias antes de poder validar un servicio.
// REGLA: deben EXISTIR PODs (pods.length > 0), NO que estén APPROVED.
export const EVIDENCE_REQUIRED_COMPANY_IDS = [7074, 4364, 17297, 1239, 5300];
